import { ReactComponent as CurrencyBuddy } from '../../assets/../assets/icons/v3/buddy-currency.svg';
import { ReactComponent as Home } from '../../assets/../assets/icons/v3/clients-portal-home.svg';
import { ReactComponent as Metrics } from '../../assets/../assets/icons/v3/clients-portal-metrics.svg';
import { ReactComponent as Plan } from '../../assets/../assets/icons/v3/clients-portal-plan.svg';
import { ReactComponent as Points } from '../../assets/../assets/icons/v3/clients-portal-points.svg';
import { ReactComponent as SearchIcon } from '../../assets/icons//search.svg';
import { ReactComponent as AddIcon } from '../../assets/icons/add-icon.svg';
import { ReactComponent as ArrowDownBlue } from '../../assets/icons/arrow-down-blue.svg';
import { ReactComponent as BenefitsIcon } from '../../assets/icons/benefits-icon.svg';
import { ReactComponent as HappyBuddy } from '../../assets/icons/buddy-happy-open-eyes.svg';
import { ReactComponent as CalendarMonth } from '../../assets/icons/calendar-month.svg';
import { ReactComponent as ChevronDownIcon } from '../../assets/icons/chevron-down-black.svg';
import { ReactComponent as CopyText } from '../../assets/icons/copy.svg';
import { ReactComponent as Download } from '../../assets/icons/download.svg';
import { ReactComponent as EditNE } from '../../assets/icons/edit-ne.svg';
import { ReactComponent as Filter } from '../../assets/icons/filter.svg';
import { ReactComponent as Meditation } from '../../assets/icons/meditation.svg';
import { ReactComponent as Refresh } from '../../assets/icons/refresh.svg';
import { ReactComponent as RewardsIcon } from '../../assets/icons/rewards-icon.svg';
import { ReactComponent as Steps } from '../../assets/icons/steps.svg';
import { ReactComponent as Training } from '../../assets/icons/training.svg';
import { ReactComponent as TrashNE } from '../../assets/icons/trash-ne.svg';
import { ReactComponent as UsersGroup } from '../../assets/icons/users-group.svg';
import { ReactComponent as ActivityMilestone } from '../../assets/icons/v3/activity-milestone.svg';
import { ReactComponent as AddPerson } from '../../assets/icons/v3/add_person.svg';
import { ReactComponent as Education } from '../../assets/icons/v3/benefits/education.svg';
import { ReactComponent as Finances } from '../../assets/icons/v3/benefits/finances.svg';
import { ReactComponent as Health } from '../../assets/icons/v3/benefits/health.svg';
import { ReactComponent as Protection } from '../../assets/icons/v3/benefits/protection.svg';
import { ReactComponent as Rewards } from '../../assets/icons/v3/benefits/rewards.svg';
import { ReactComponent as WellBeing } from '../../assets/icons/v3/benefits/well-being.svg';
import { ReactComponent as Billing } from '../../assets/icons/v3/billing.svg';
import { ReactComponent as DownloadBlackIcon } from '../../assets/icons/v3/black-download.svg';
import { ReactComponent as CheckCirclev2 } from '../../assets/icons/v3/check-circle-v2.svg';
import { ReactComponent as ChevronDownV3 } from '../../assets/icons/v3/chevron-down.svg';
import { ReactComponent as ChevronLeft } from '../../assets/icons/v3/chevron-left.svg';
import { ReactComponent as ChevronRight } from '../../assets/icons/v3/chevron-right.svg';
import { ReactComponent as ChevronUpV3 } from '../../assets/icons/v3/chevron-up.svg';
import { ReactComponent as CommunicationsIcon } from '../../assets/icons/v3/clients-portal-comunicate.svg';
import { ReactComponent as ClockIcon } from '../../assets/icons/v3/clock.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/v3/close.svg';
import { ReactComponent as CopyTextV2 } from '../../assets/icons/v3/copy-v2.svg';
import { ReactComponent as DeleteV3 } from '../../assets/icons/v3/delete.svg';
import { ReactComponent as DownloadSimple } from '../../assets/icons/v3/download-simple.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/v3/download.svg';
import { ReactComponent as Emails } from '../../assets/icons/v3/emails.svg';
import { ReactComponent as Employees } from '../../assets/icons/v3/employees.svg';
import { ReactComponent as EndChallenge } from '../../assets/icons/v3/end-challenge.svg';
import { ReactComponent as FlagBanner } from '../../assets/icons/v3/flag-banner.svg';
import { ReactComponent as Flag } from '../../assets/icons/v3/flag.svg';
import { ReactComponent as TrainingEducation } from '../../assets/icons/v3/graduation-icon.svg';
import { ReactComponent as HealthInsurance } from '../../assets/icons/v3/health-insurance.svg';
import { ReactComponent as InsuranceCoverage } from '../../assets/icons/v3/insurance-coverage.svg';
import { ReactComponent as ArrowLeft } from '../../assets/icons/v3/left-arrow.svg';
import { ReactComponent as Email } from '../../assets/icons/v3/mail.svg';
import { ReactComponent as MedalIcon } from '../../assets/icons/v3/medal.svg';
import { ReactComponent as NorthEastArrow } from '../../assets/icons/v3/north-east-arrow.svg';
import { ReactComponent as OptionsV3 } from '../../assets/icons/v3/options.svg';
import { ReactComponent as OutWhiteIcon } from '../../assets/icons/v3/out-white.svg';
import { ReactComponent as OutIcon } from '../../assets/icons/v3/out.svg';
import { ReactComponent as PersonMulti } from '../../assets/icons/v3/person-multi.svg';
import { ReactComponent as PersonMultiple } from '../../assets/icons/v3/person-multiple.svg';
import { ReactComponent as RemovePerson } from '../../assets/icons/v3/remove_person.svg';
import { ReactComponent as ArrowRight } from '../../assets/icons/v3/right-arrow.svg';
import { ReactComponent as Share } from '../../assets/icons/v3/share.svg';
import { ReactComponent as SportMedal } from '../../assets/icons/v3/sport-medal.svg';
import { ReactComponent as CheckIcon } from '../../assets/icons/v3/success.svg';
import { ReactComponent as SucessCheck } from '../../assets/icons/v3/sucess_v2.svg';
import { ReactComponent as ThumbsDown } from '../../assets/icons/v3/thumbs-down.svg';
import { ReactComponent as ThumbsUp } from '../../assets/icons/v3/thumbs-up.svg';
import { ReactComponent as Time } from '../../assets/icons/v3/time.svg';
import { ReactComponent as TrashV3 } from '../../assets/icons/v3/trash-can.svg';
import { ReactComponent as Upload } from '../../assets/icons/v3/upload.svg';
import { ReactComponent as UserDefault } from '../../assets/icons/v3/user-picture.svg';
import { ReactComponent as XErrorIcon } from '../../assets/icons/v3/xerror.svg';
import { ReactComponent as OpenEye } from '../../assets/icons/visibility.svg';
import { IButtonImage, IButtonImageV3 } from '../interfaces/button';
import { IBdsIconButtonImage } from '../interfaces/buttons';
import { ITabBarButtonImage } from '../interfaces/tabbars';

export const HOME = {
  icon: Home
};
export const POINTS = {
  icon: Points
};
export const METRICS = {
  icon: Metrics
};
export const PLAN = {
  icon: Plan
};
export const BENEFITS = {
  icon: BenefitsIcon
};
export const COLLABORATORS = {
  icon: Employees
};

export const REWARDS = {
  icon: RewardsIcon
};
export const COMMUNICATIONS: IButtonImage = {
  component: CommunicationsIcon,
  position: 'left'
};

export const CALENDAR_MONTH: IButtonImage = {
  component: CalendarMonth,
  position: 'right'
};

export const DOWNLOAD_IMAGES: IButtonImage = {
  component: Download,
  position: 'right'
};

export const FILTER_IMAGES: IButtonImage = {
  component: Filter,
  position: 'right'
};

export const MEDAL: IButtonImage = {
  component: MedalIcon,
  position: 'left'
};

export const TRASH_V3: IButtonImage = {
  component: TrashV3,
  position: 'right'
};

export const EMAIL: IButtonImage = {
  normal: Email,
  position: 'right',
  component: Email
};

export const ARROW_DOWN_IMAGES: IButtonImage = {
  component: ArrowDownBlue,
  position: 'right'
};

export const TRASH_NE: IButtonImage = {
  normal: TrashNE,
  position: 'right',
  component: TrashNE
};

export const TRASH_BTN_NE: IButtonImage = {
  normal: TrashNE,
  position: 'left',
  component: TrashNE
};

export const EDIT_NE: IButtonImage = {
  normal: EditNE,
  position: 'right',
  component: EditNE
};

export const EDIT_BTN_NE: IButtonImage = {
  normal: EditNE,
  position: 'left',
  component: EditNE
};

export const REFRESH_IMAGE: IButtonImage = {
  component: Refresh,
  position: 'left'
};

export const OPEN_EYE_IMAGE: IButtonImage = {
  component: OpenEye,
  position: 'left'
};

export const STEPS_HABIT: IButtonImage = {
  component: Steps,
  position: 'left'
};

export const SPORT_MEDAL: IButtonImageV3 = {
  component: SportMedal,
  type: 'stroke'
};

export const MEDITATION_HABIT: IButtonImage = {
  component: Meditation,
  position: 'left'
};

export const TRAINING_HABIT: IButtonImage = {
  component: Training,
  position: 'left'
};

export const ADD_ICON: IButtonImage = {
  component: AddIcon,
  position: 'left'
};

export const CHEVRON_RIGHT_ICON: IBdsIconButtonImage = {
  component: ChevronRight
};

export const CHEVRON_LEFT_ICON: IBdsIconButtonImage = {
  component: ChevronLeft
};

export const CLOSE_ICON: IBdsIconButtonImage = {
  component: CloseIcon
};

export const DOWNLOAD_ICON: IBdsIconButtonImage = {
  component: DownloadIcon
};

export const DOWNLOAD_BLACK_ICON: IBdsIconButtonImage = {
  component: DownloadBlackIcon
};

export const EDUCATION_ICON: ITabBarButtonImage = {
  component: Education
};

export const FINANCES_ICON: ITabBarButtonImage = {
  component: Finances
};

export const HEALTH_ICON: ITabBarButtonImage = {
  component: Health
};

export const PROTECTION_ICON: ITabBarButtonImage = {
  component: Protection
};

export const REWARDS_ICON: ITabBarButtonImage = {
  component: Rewards
};

export const WELL_BEING_ICON: ITabBarButtonImage = {
  component: WellBeing
};

export const FLAG_ICON: IButtonImageV3 = {
  component: Flag,
  type: 'fill'
};

export const BILLING_ICON: IButtonImageV3 = {
  component: Billing,
  type: 'fill'
};

export const END_CHALLENGE_ICON: IButtonImageV3 = {
  component: EndChallenge,
  type: 'fill'
};

export const EMPLOYEES_ICON: IButtonImageV3 = {
  component: Employees,
  type: 'fill'
};

export const ARROW_RIGHT_ICON: IButtonImageV3 = {
  component: ArrowRight,
  type: 'fill'
};
export const SEARCH_ICON: IButtonImageV3 = {
  component: SearchIcon,
  type: 'stroke'
};

export const ARROW_LEFT_ICON: IButtonImageV3 = {
  component: ArrowLeft,
  type: 'fill'
};

export const SHARE_ICON: IButtonImageV3 = {
  component: Share,
  type: 'fill'
};

export const COPY_TEXT_ICON: IButtonImageV3 = {
  component: CopyText,
  type: 'fill'
};

export const COPY_TEXT_V2_ICON: IButtonImageV3 = {
  component: CopyTextV2,
  type: 'fill'
};

export const CHECK_ICON: IButtonImageV3 = {
  component: CheckIcon,
  type: 'fill'
};

export const CHECK_ICON_V2: IButtonImageV3 = {
  component: SucessCheck,
  type: 'fill'
};

export const USER_DEFAULT_ICON: IButtonImageV3 = {
  component: UserDefault,
  type: 'fill'
};

export const USERS_GROUP_ICON: IButtonImageV3 = {
  component: UsersGroup,
  type: 'fill'
};

export const CHEVRON_DOWN_V3: IButtonImageV3 = {
  component: ChevronDownV3,
  type: 'fill'
};

export const CHEVRON_UP_V3: IButtonImageV3 = {
  component: ChevronUpV3,
  type: 'fill'
};

export const OUT_ICON: IButtonImageV3 = {
  component: OutIcon,
  type: 'fill'
};

export const OUT_WHITE_ICON: IButtonImageV3 = {
  component: OutWhiteIcon,
  type: 'fill'
};

export const CHALLENGES_ICON: IButtonImageV3 = {
  component: MedalIcon,
  type: 'fill'
};

export const DELETE_V3: IButtonImageV3 = {
  component: DeleteV3,
  type: 'fill'
};

export const NORTH_EAST_ARROW: IButtonImageV3 = {
  component: NorthEastArrow,
  type: 'fill'
};

export const TIME_ICON: IButtonImageV3 = {
  component: Time,
  type: 'fill'
};

export const INSURANCE_COVERAGE: IButtonImageV3 = {
  component: InsuranceCoverage,
  type: 'stroke'
};

export const OPTIONS_ICON: IButtonImageV3 = {
  component: OptionsV3,
  type: 'fill'
};

export const REMOVE_PERSON: IButtonImageV3 = {
  component: RemovePerson,
  type: 'stroke'
};

export const PERSON_MULTI: IButtonImageV3 = {
  component: PersonMulti,
  type: 'stroke'
};

export const PERSON_MULTIPLE: IButtonImageV3 = {
  component: PersonMultiple,
  type: 'stroke'
};

export const ADD_PERSON: IButtonImageV3 = {
  component: AddPerson,
  type: 'stroke'
};
export const HAPPY_BUDDY: IButtonImageV3 = {
  component: HappyBuddy,
  type: 'fill'
};

export const EMAILS_ICON: IButtonImageV3 = {
  component: Emails,
  type: 'fill'
};

export const EMAIL_ICON: IButtonImageV3 = {
  component: Email,
  type: 'fill'
};

export const UPLOAD_ICON: IButtonImageV3 = {
  component: Upload,
  type: 'fill'
};

export const CURRENCY_BUDDY: IButtonImageV3 = {
  component: CurrencyBuddy,
  type: 'fill'
};

export const CLOCK_ICON: IButtonImageV3 = {
  component: ClockIcon,
  type: 'fill'
};

export const CHECK_CIRCLE_V2: IButtonImageV3 = {
  component: CheckCirclev2,
  type: 'fill'
};

export const XERROR_ICON: IButtonImageV3 = {
  component: XErrorIcon,
  type: 'fill'
};

export const FLAG_BANNER_ICON: IButtonImageV3 = {
  component: FlagBanner,
  type: 'fill'
};

export const DOWNLOAD_SIMPLE: IBdsIconButtonImage = {
  component: DownloadSimple
};

export const THUMBS_DOWN_ICON: IBdsIconButtonImage = {
  component: ThumbsDown
};

export const THUMBS_UP_ICON: IBdsIconButtonImage = {
  component: ThumbsUp
};

export const TRAINING_EDUCATION_ICON: IButtonImageV3 = {
  component: TrainingEducation,
  type: 'fill'
};

export const ACTIVITY_MILESTONE_ICON: IButtonImageV3 = {
  component: ActivityMilestone,
  type: 'fill'
};

export const PLAN_ICON: IButtonImageV3 = {
  component: Plan,
  type: 'fill'
};

export const HEALTH_INSURANCE_ICON: IButtonImageV3 = {
  component: HealthInsurance,
  type: 'stroke'
};
